export default __webpack_public_path__ + "static/media/Logo Respinos 4.cf31f620.png";